/* eslint-disable no-nested-ternary */
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store/root-reducer';
import { ProspectProfileHeaderBlock } from '../../../prospect/components/prospect-list/components/prospect-details/prospect-details-modal/components/prospect-profile-header-block';
import { executeOnRequestStatus } from '../../../../shared/utils';
import { resetTaskerState } from '../../tasks-slice';

export type TaskerCallModalProps = {
  /** Loads full prospect profile (same payload as prospect details) when set. */
  prospectId?: number | null;
  /** Optional kebab menu; omit to show DotsVertical like prospect profile. */
  dropDownActions?: React.ReactNode;
  className?: string;
  /** When provided, renders a "Do Not Call" icon button instead of the kebab dropdown. */
  onDoNotContactClick?: () => void;
  sendGetSingleProspectDetailsRequest?: (prospectId: number) => void;
  currentData?: any;
};

/**
 * Call/task surface: same prospect header UI/UX as prospect-profile-section (avatar, name,
 * job/company/website, social links, optional dropdown). Data from Redux `getSingleProspect`
 * after `getSingleProspectDetailsRequest(prospectId)`.
 */
const TaskerCallModal: React.FC<TaskerCallModalProps> = ({
  prospectId,
  dropDownActions,
  className,
  onDoNotContactClick,
  // sendGetSingleProspectDetailsRequest,
  currentData,
}) => {
  const dispatch = useDispatch();

  const getTaskerDataRequestStatus = useSelector(
    (state: RootState) => state.tasks.getTaskerDataRequest.status,
  );
  const isAgencyUser = useSelector(
    (state: RootState) => state?.home?.isAgencyUser,
  );

  const item = useMemo(() => {
    const raw = currentData;
    if (!raw) return null;
    return Array.isArray(raw) ? raw[0] : raw;
  }, [currentData]);

  useEffect(() => {
    executeOnRequestStatus({
      status: getTaskerDataRequestStatus,
      onSuccess: () => {
        dispatch(resetTaskerState());
      },
      onFailed: () => {
        dispatch(resetTaskerState());
      },
    });
  }, [getTaskerDataRequestStatus, prospectId]);

  return (
    <div
      className={`prospect-profile-section-container ${className ?? ''}`.trim()}
    >
      <ProspectProfileHeaderBlock
        item={item}
        dropDownActions={dropDownActions}
        dropdownId={`tasker-call-modal-prospect-${
          item?.id ?? prospectId ?? 'prospect'
        }`}
        onDoNotContactClick={onDoNotContactClick}
        profileHeaderFromDialer={true}
        isAgencyUser={isAgencyUser}
      />
    </div>
  );
};

export default TaskerCallModal;
